import { DropTarget } from 'react-dnd';
import { DnDTypes } from '../common/Constants';
import Discover from '../common/redux/actions/DiscoverActions';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import _, { isFunction } from 'lodash';
import { Viz } from './VizUtil';
import { addFieldDispatch } from './viz-layout-panel/viz-layout-panel.utils';
import { shortid } from '../common/utilities/shortid-adapter';

const ShelfDropLocation = ({
  isOver,
  canDrop,
  connectDropTarget,
  children,
}) => {
  return connectDropTarget(
    <div>
      <div
        className={`shelf-drop-location ${
          isOver && canDrop ? 'drop-valid' : ''
        }`}
      />
      {children}
    </div>,
  );
};
const sdlTarget = {
  drop(props, monitor) {
    // if the field is already on a shelf, remove it
    const reduxTransactionId = `drop${shortid.generate()}`;
    let { field, shelf: fromShelf } = monitor.getItem();
    const { shelf: toShelf } = props;
    if (!_.isEqual(toShelf?.id, 'SLICER') && !_.isEmpty(field.children)) {
      // set the field we are dropping to the first one not in-play in of the children
      let firstOneLeft;
      field.children.some(child => {
        const isInPlay = Viz.isFieldInPlay(child.name, props.layout);
        if (_.isNil(isInPlay)) {
          firstOneLeft = child;
          return true;
        }
        return false;
      });
      field = _.isNil(firstOneLeft) ? field : firstOneLeft;
    }

    const from = Viz.findShelvesContainingField(props.layout, field.name);
    const fromWithoutSlicer = _.without(from, 'SLICER');
    const fieldOnlyOnSlicer = _.isEmpty(fromWithoutSlicer);
    const draggedFromSlicer = fromShelf?.id === 'SLICER';
    const draggedToSlicer = props.shelf.id === 'SLICER';
    const movingInSameShelf =
      !_.isNil(fromShelf) && fromShelf?.id === props.shelf?.id;

    let moveToShelf = _.head(fromWithoutSlicer);

    if (
      (fieldOnlyOnSlicer ||
        (draggedFromSlicer && fieldOnlyOnSlicer) ||
        draggedToSlicer) &&
      !movingInSameShelf
    ) {
      props.addField({
        discoveryId: props.discoveryId,
        chartType: props.chartSpec?.id,
        field,
        shelf: props.shelf.id,
        layout: props.layout,
        index: props.index,
        reduxTransactionId,
      });
    } else {
      if (movingInSameShelf) {
        moveToShelf = props.shelf.id;
      }
      props.moveFieldToAnotherShelf(
        field,
        moveToShelf,
        props.shelf.id,
        props.index,
        reduxTransactionId,
      );
    }
  },
  canDrop(props, monitor) {
    const { field, shelf: fromShelf } = monitor.getItem();
    const shelfId = props.shelf.id;
    const { layout } = props;

    const validFieldForShelf =
      isFunction(props?.chartSpec?.validateFieldForShelf) &&
      props.chartSpec.validateFieldForShelf(field, shelfId, layout, fromShelf);
    const currentIndexInShelf = props.layout[shelfId].findIndex(
      f => f.name === field.name,
    );

    if (currentIndexInShelf > -1) {
      const isValidLocationWithinTheShelf =
        currentIndexInShelf !== props.index &&
        currentIndexInShelf + 1 !== props.index;
      return validFieldForShelf && isValidLocationWithinTheShelf;
    }
    return validFieldForShelf;
  },
};
const sdlCollect = (connectComponent, monitor) => {
  return {
    connectDropTarget: connectComponent.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
};
const mapStateToProps = () => {
  return {};
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addField: addFieldDispatch(dispatch),
    removeField: (field, shelf, reduxTransactionId) => {
      dispatch(
        Discover.removeFieldFromVisualization(
          ownProps.discoveryId,
          field,
          shelf,
          reduxTransactionId,
        ),
      );
    },
    moveFieldToAnotherShelf: (
      field,
      fromShelf,
      toShelf,
      index,
      reduxTransactionId,
    ) => {
      dispatch(
        Discover.moveFieldToAnotherShelf(
          ownProps.discoveryId,
          field,
          fromShelf,
          toShelf,
          index,
          reduxTransactionId,
        ),
      );
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  DropTarget(DnDTypes.VIZ_FIELD, sdlTarget, sdlCollect),
)(ShelfDropLocation);
